export const PATH_AFTER_ACCOUNT_REGISTRATION = '/register?q=username';
